
import React from 'react'
import "./homepage.css";
import { AiOutlineFacebook } from "react-icons/ai";
import {BsWhatsapp} from "react-icons/bs";

import { Link, useNavigate } from 'react-router-dom';
import { CategoryCard } from '../Components/HomePage/CategoryCard';
import { WhyCard } from '../Components/HomePage/WhyCard';
import { MyCarousel } from "../Components/HomePage/Carousel"

import { FeaturedSlider } from '../Components/HomePage/FeaturesSlider';
import { SuccessStories } from '../Components/HomePage/SuccessStories';



export const HomePage = () => {
  const navigate = useNavigate();
  const handleFundraiser = () => {
    navigate("/medical");
  }

  return (
    <div>

      {/* part 1 hero image */}
      <div className="rs-banner">
        <div className="rs-banner-img">
          <img src="https://kettocdn.gumlet.io/media/banner/0/71/image/626a109be777492340e46d013c3cad0857a5da3a.png?w=1366&dpr=1.0" height="800px" width='100%'alt=""/>
        </div>
        <div className="rs-banner-title">
          <h1 className="rs-head">Need Funds to Pay For a Medical Emergency or Social Cause?</h1>
          <br/>
          <div className="rs-title-flex">
            <div style={{ width: "200px" }}>
              <h3 className="rs-skyblue">0%</h3>
              <p className="rs-lightgray">PLATFORM FEE</p>
            </div>
            <div style={{ flexBasis: "200px" }}>
              <h3 className="rs-skyblue">55 Lakh+</h3>
              <p className="rs-lightgray">DONORS</p>
            </div>
            <div style={{ flexBasis: "200px" }}>
              <h3 className="rs-skyblue">2 Lakh+</h3>
              <p className="rs-lightgray">FUNDRAISERS</p>
            </div>
          </div>
          <br/>
          <div className="rs-skyblue small-p">Ketto’s <b style={{ fontSize: "25px" }}
          >0%</b> <b>Platform fees</b> ensures maximum funds for you</div>
          <br/>
          <div style={{textAlign:"center",marginLeft:'-15%'}}>
            <button className="rs-skyblue-btn" onClick={handleFundraiser}>Start a Fundraiser for FREE</button>
            <br/>
            <div className="rs-skyblue">नि: शुल्क फंडरेजर शुरू करें </div>
            <br/>
            {/* icon*/}
            </div>
        </div>
      </div > 

      {/* part -1b */}
      <div className="rs-image-2">
        <div className="img-2">
          <img src="https://kettocdn.gumlet.io/media/banner/0/92/image/81d7a1a7626397c32f6c1fb83bfdf476ccd734af.png" atl="start-monthly-donation-to-save-lives" 
          width="100%" height="100%"
          />
        </div>
        <div className="text-div">
          <h3 className='blue'>Start Monthly Donation to Save Lives</h3>
          <p className='rs-lightgray-text' >With your support, countless children will receive health care and a happy life. Start your monthly donation today.</p>
        </div>
        <button className='rs-blue-btn'><Link to='/donate'>Donate Now</Link> </button>
      </div>

      {/* fundraisers carousel */}
      
      <div className="rs-carousal-1">
        <h3 className="rs-head" >Trending Fundraisers</h3>
        <p className='rs-lightgray subhead'>View the fundraisers that are most active right now</p>
          <MyCarousel  />
      </div>
      {/*  video div*/}
      <div className="rs-video">
        <h1 className='rs-head t-center'>Start a Fundraiser in three simple steps</h1>
        <div className='rs-video-div'>
            <div className="rs-video-img">
              <img src="https://ketto.gumlet.io/assets/images/homepage/sac-separator.png?w=480&dpr=1.0" height="100%" />
          </div>
          
          <div className="rs-video-data">
            <div >
              <h5 className="rs-video-head">Start your fundraiser</h5>
              <p className="rs-video-subhead">It’ll take only 2 minutes. Just tell us a few details about you and the ones you are raising funds for.</p>
            </div>
            <div >
              <h5 className="rs-video-head">Share your fundraiser</h5>
              <p className="rs-video-subhead">All you need to do is share the fundraiser with your friends and family. In no time, support will start pouring in.</p>
              <br/>
              <p className="rs-video-p">Share your fundraiser directly from dashboard on social media.</p>
            </div>
            <div >
              <h5 className="rs-video-head">Withdraw Funds</h5>
              <p className="rs-video-subhead">The funds raised can be withdrawn without any hassle directly to your bank account.</p>
              <br/>
              <p className="rs-video-p">It takes only 5 minutes to withdraw funds on ketto.</p>
            </div>
          </div>
          <div className="rs-v-div">
          <video autoPlay muted loop playsInline width="100%" height="250px" >
<source src="https://www.ketto.org/assets/videos/screen_recording.webm" type="video/mp4"/> 
</video>
          </div>
        </div>
      </div>

      {/* chat button div */}
      <div className='rs-chat-div'>
        <button className='rs-skyblue-btn c' onClick={handleFundraiser}>START A FUNDRAISER FOR FREE</button>
        <button className='rs-talk-btn c v'>TALK TO US</button>
      </div>
      {/* chats */}
      <div className='rs-chat-div d' >
        <p className='rs-video-subhead'>Have any questions for us? Chat with our team on Facebook or WhatsApp now.</p>
        <div className='rs-ic'>
        <button className='rs-c-btn bg-b'><AiOutlineFacebook size={'28px'}/>CHAT WITH US</button>
        <button className='rs-c-btn bg-g'><BsWhatsapp size={'28px'} />CHAT WITH US</button>
        </div>
        </div>
      {/* video-2 div */}
       
        <div className='rs-video-div v2' >
          <div className=" i2"style={{width:'50%'}}>
            <img src="https://ketto.gumlet.io/assets/images/homepage/mcd-app-homepage.png?w=640&dpr=1.0" alt=""/>
          </div>
          <div style={{
          display: 'flex', flexWrap: 'wrap',textAlign:'center',gap:'10px',
            width:'80%',marginTop:'10%'
          }}>
          <h1 className='rs-head'>Manage your fundraisers on the go</h1>
          <div style={{
            display: 'flex', flexWrap: 'wrap', margin: 'auto',
            marginTop:'-20%'
          }}>
            <div className='v2flex'>
              <img src="https://ketto.gumlet.io/assets/images/download/phone.png?w=50&dpr=1.0" width='100px' alt=""/>
              <p>Access a personalized dashboard</p>
            </div>
            <div className='v2flex'>
              <img src="https://ketto.gumlet.io/assets/images/download/withdraw.png?w=50&dpr=1.0" alt=""width='100px'/>
              <p>Withdraw your funds faster</p>
            </div>
            <div className='v2flex'>
              <img src="https://ketto.gumlet.io/assets/images/download/piggy-bank.png?w=50&dpr=1.0" alt=""width='100px'/>
              <p>Keep track of all your donations received</p>
            </div>
            <div className='v2flex'>
              <img src="https://ketto.gumlet.io/assets/images/download/support.png?w=70&dpr=1.0" alt=""width='100px'/>
              <p>Start fundraisers within seconds</p>
            </div>
            </div>
          </div>
        </div>
      {/* category div */}
      <div className='rs-cat'>
      <div className='rs-cat-head'>
        <h1 className='rs-head'>Causes you can raise funds for</h1>
        <p className='rs-video-subhead'>Be it for a personal need, social cause or a creative idea - you can count on us for
the project that you want to raise funds for.</p>
        </div>
        <div className='rs-cat-flex'>
          {cat?.map((e) => (
            <CategoryCard key={e.label} label={e.label} />
          ))}
        </div>
        </div>
      {/* why div */}

      <div className='rs-cat w'>
      <div className='rs-cat-head'>
        <h1 className='rs-head'>Why Ketto?</h1>
        </div>
        <div className='rs-cat-flex rs-w'>
          {whyCat?.map((e) => (
            <WhyCard key={e.label} label={e.label} img={e.img} />
          ))}
        </div>
        </div>
      {/*select stories div  */}
      <div>
        <h1 className='rs-head' style={{ textAlign:'center',marginTop:'5%'}}>Success Stories</h1>
        <SuccessStories/>
      </div>
      {/* buttons */}
      <div className='rs-chat-div d2'>
        <button className='rs-skyblue-btn c' onClick={handleFundraiser}>START A FUNDRAISER FOR FREE</button>
        <button className='rs-talk-btn c vt'>TALK TO US</button>
      </div>
      {/* featured div */}
      <div>
        <h1 className='rs-head' style={{textAlign:'center'}}>Featured In</h1>
        <FeaturedSlider/>

      </div>
      {/* chat-2 div */}
      <div className='rs-chat-div d' >
        <p className='rs-video-subhead'>Have any questions for us? Chat with our team on Facebook or WhatsApp now.</p>
        <div className='rs-ic'>
        <button className='rs-c-btn bg-b'><AiOutlineFacebook size={'28px'}/>CHAT WITH US</button>
        <button className='rs-c-btn bg-g'><BsWhatsapp size={'28px'} />CHAT WITH US</button>
        </div>
        </div>
    </div>
  )
}

const cat=[
  { label: "MEDICAL", icon: "FaBriefcaseMedica",pref:"FaBriefcaseMedical"},
  { label: "MEMORIAL", icon: "",pref:"" },
  { label: "CHILDREN", icon: "",pref:""},
  { label: "EDUCATION", icon: "",pref:"" },
  { label: "ANIMAL", icon: "",pref:"" },
  { label: "OTHERS", icon: "",pref:"" },
]
const whyCat = [
  { img: "https://encrypted-tbn2.gstatic.com/images?q=tbn:ANd9GcS9SasrS3MBV_ga0lqLDOd6RNa8O6Cj8_Czqu4NehFVvmHX55rT", label: "Industry’s best fundraising success rate" },
  { img: "https://static.wixstatic.com/media/644c6d_e3d23230518345c2a04ce9f8f1080eda~mv2.png/v1/fill/w_119,h_119,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/644c6d_e3d23230518345c2a04ce9f8f1080eda~mv2.png", label: "Supported By 55,00,000+ Donors" },
  {img:"https://www.fleetcare.com.au/Fleetcare/media/Images/Tabbed%20Reasons/Tabbed-Reason-Images-Repairs-On-time.png?ext=.png",label:"Easy-To-Manage Tools To Boost Results"},
  { img: "https://mystudentguide.collegelasalle.com/assets/images/card-icon-2-364x360.png", label: "Receive donations via all popular payment modes" },
  { img: "http://migrationmatters.me/wp-content/uploads/2016/08/Questions-600x600.png", label: "Get Expert Support 24/7" },
  {
    img:"https://www.issgovernance.com/file/2019/02/license-300x300.png",label:"A Dedicated Smart-Dashboard"
  },
  { img: "https://cdn-icons-png.flaticon.com/512/871/871717.png", label: "Withdraw Funds Without Hassle" },
  {img:"https://www.pefa.org/sites/pefa/files/inline-images/000.PNG",label:"International Payment Support"},
]

/*var featuresData = [
    // phone image url
    "https://ketto.gumlet.io/assets/images/homepage/mcd-app-homepage.png?w=640&dpr=1.0",

    "https://ketto.gumlet.io/assets/images/homepage/sac-separator.png?w=480&dpr=1.0",
    "https://ketto.gumlet.io/assets/images/homepage/sac-separator.png?w=480&dpr=1.0",
    "https://ketto.gumlet.io/assets/images/homepage/sac-separator.png?w=480&dpr=1.0",

    "https://ketto.gumlet.io/assets/images/homepage/sac-separator.png?w=480&dpr=1.0",

    // logo
    "https://kettocdn.gumlet.io/images/logo-light-bg.svg",
    "https://www.ketto.org/assets/icons/apple/apple-icon-57x57.png",

    // funds images
    "https://ketto.gumlet.io/assets/images/download/phone.png?w=70&dpr=1.0",
    "https://ketto.gumlet.io/assets/images/download/withdraw.png?w=70&dpr=1.0",
    "https://ketto.gumlet.io/assets/images/download/piggy-bank.png?w=70&dpr=1.0",
    "https://ketto.gumlet.io/assets/images/download/support.png?w=70&dpr=1.0"

];
 */

